import React from 'react';
import Button from '../../../shared/components/atoms/button/button';
import useHomeLinkMode from '../../../shared/hooks/useHomeLinkMode';
import './pass-force-confirmation.scss';

const PassForceConfirmation = () => {

    const { homeLink } = useHomeLinkMode();

    return (
        <div className="f-m-PassForceConfirmation">
            <p className="f-m-PassForceConfirmation__title">¡Tu contraseña ha sido actualizada!</p>
            <Button className="f-a-button__primary-purple f-a-button__extra-big "
                id="f-a-button__PassForceConfirmation"
                copy={"Aceptar"}
                onclick={() => {
                    location.href = ((sessionStorage.getItem("PREVIOUS_PAGE") !== null) ? (sessionStorage.getItem("PREVIOUS_PAGE")) : homeLink)
                }}
            />
        </div>
    )
}

export default PassForceConfirmation